import { render } from "./ImageComponent.vue?vue&type=template&id=c438d578&scoped=true"
import script from "./ImageComponent.vue?vue&type=script&lang=js"
export * from "./ImageComponent.vue?vue&type=script&lang=js"

import "./ImageComponent.vue?vue&type=style&index=0&id=c438d578&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c438d578"]])

export default __exports__